export default __webpack_public_path__ + "static/media/elss-fund.b5011451.gif";